import { update_window_type } from '../../redux/Slice/windowTypeSlice';
import {
  setHotspotBillboardEnabled,
  prepareHotspotsForDesignMode,
  syncHotspotDesignQuaternion,
} from '../../components/gridpagefunction/HotSpot';
import store from '../../redux/store';
import { sceneStateHelper } from '../ThreeJsUtils/SceneStateHelper';
import { disablePreviewPhysics } from '../Physics/PhysicsUtils';
import { stopPreviewTimelinePlayback } from './startAllSceneAnimations';
import {
  clearSceneParticleLifeTimeouts,
} from '../particles/lifeUtils';
import { resumeSceneParticleAnimations } from '../particles/particleAnimationUtils';

const getHotspotList = () =>
  store.getState().assets_object?.sceneHotspots || [];

const applyHotspotBillboard = (enabled) => {
  const hotspotList = getHotspotList();
  hotspotList.forEach((hp) => {
    try {
      setHotspotBillboardEnabled(hp, enabled);
    } catch (_) {}
  });
};

/**
 * Same steps as TabContainer design tab click: restore preview state,
 * switch window type back to design, disable hotspot billboards.
 */
export function exitPreviewMode({
  dispatch,
  scene,
  currentWindowType,
  completeObject,
}) {
  const currentScene = scene;
  if (!currentScene || currentWindowType === 'design') return;

  if (currentWindowType === 'preview') {
    // Stop physics + preview animations BEFORE restoring transforms.
    disablePreviewPhysics();
    stopPreviewTimelinePlayback();
    if (typeof completeObject?.stopAllAnimations === 'function') {
      completeObject.stopAllAnimations();
    }

    // Stop face-camera before restore — preview billboard mutates quaternion each frame.
    prepareHotspotsForDesignMode(getHotspotList());

    if (sceneStateHelper.hasSavedStates()) {
      sceneStateHelper.restoreStates(currentScene);
      sceneStateHelper.clear();
    }

    // Re-sync design quaternions from restored scene state.
    getHotspotList().forEach((hp) => {
      try {
        syncHotspotDesignQuaternion(hp);
      } catch (_) {}
    });

    // Clear preview life timers and restart particles for design.
    clearSceneParticleLifeTimeouts(currentScene);
  }

  dispatch(
    update_window_type({
      type: 'design',
      current_type: currentWindowType,
      scene: currentScene,
    })
  );

  if (currentWindowType === 'preview') {
    // After window_type is design, resume particles without scheduling expiry.
    resumeSceneParticleAnimations(currentScene);
    requestAnimationFrame(() => {
      applyHotspotBillboard(false);
    });
  }
}
